<template>
    <div>
        <div class="card dashcard mb-3">
            <div class="card-body">
                <div class="form-row"> 
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtros" :blockano="true" :sync="true" @sync="load(false)" />
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input
                            type="select"
                            placeholder="Todos os Status"
                            :optionsList="[
                                { id: 'L', search: 'Disponíveis' },
                                { id: 'Z', search: 'Disponíveis (Novos)' },
                                { id: 'P', search: 'Pendentes' },
                                { id: 'N', search: 'Recoletas' }
                            ]"
                            optionsData="id"
                            v-model="filtros.status" />
                    </div>
                    <div class="col col-12 col-md-4">
                        <az-input
                            placeholder="Pesquisar..."
                            v-model="filtros.pesquisa">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button type="button" class="btn btn-outline-dark" @click="filtros.info_proc = !filtros.info_proc" title="Filtrar por Procedimento" data-toggle="tooltip">
                                        <i class="fa-solid fa-play"></i>
                                    </button>

                                    <button type="button" class="btn btn-outline-dark" @click="filtros.info_pac = !filtros.info_pac" title="Filtrar por Paciente" data-toggle="tooltip">
                                        <i class="fa-solid fa-user-injured"></i>
                                    </button>

                                    <button type="button" class="btn btn-outline-dark" @click="filtros.horarios = !filtros.horarios" title="Filtrar por Faixa de Horário" data-toggle="tooltip">
                                        <i class="fa-solid fa-clock"></i>
                                    </button>

                                    <button type="button" class="btn btn-outline-dark" @click="imprimindo_etiquetas = !imprimindo_etiquetas" title="Imprimir" data-toggle="tooltip" :disabled="!imprimindo_etiquetas && !lista.length">
                                        <i class="fa-solid fa-print"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                </div>

                <div class="form-row mt-2" v-if="filtros.info_proc">
                    <div class="col col-12">
                        <az-input
                            placeholder="Procedimento..."
                            icon="fa-solid fa-play fa-fw"
                            type="autocomplete"
                            optionsMode="aql"
                            optionsName="procedimentos.combos.agenda.op.g"
                            :optionsSync="false"
                            v-model="filtros.procedimento"
                            ref="info_procedimento"
                            :procsigla="true">
                        </az-input>
                    </div>
                </div>

                <div class="form-row mt-2" v-if="filtros.horarios">
                    <div class="col col-12 col-md-2 offset-md-2">
                        <az-input   
                            type="time"
                            icon="fa-solid fa-greater-than-equal"
                            v-model="filtros.hora_inicio" />
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input   
                            type="time"
                            icon="fa-solid fa-less-than-equal"
                            v-model="filtros.hora_fim" />
                    </div>
                </div>

                <div class="form-row mt-2" v-if="filtros.info_pac">
                    <div class="col col-12">
                        <az-input 
                            icon="fa-solid fa-user-injured fa-fw"
                            placeholder="Selecionar Paciente..."
                            icon2="fas fa-search"
                            type="autocomplete" 
                            optionsMode="aql"
                            service="pacientes.index"
                            optionsDisplay="search"
                            :optionsParm="{ portal: 1 }"
                            v-model="filtros.paciente" 
                            :shortkey="['ctrl', 'm']" 
                            :optimized_ac="true">
                        </az-input>
                    </div>
                </div>
            </div>
        </div>

        <!-- Importar XML Padrão Smart -->
        <div class="mb-3" v-if="$store.state.user && $store.state.user.model && $store.state.user.model.st_tipo_acesso == 'S'">
            <importar-xml-smart 
                :portal="true"
                @buscar="buscar"
                ></importar-xml-smart>
        </div>

        <!-- Importar XML Padrão Nephrosys -->
        <div class="mb-3" v-if="$store.state.user && $store.state.user.model && $store.state.user.model.st_tipo_acesso == 'N'">
            <importar-txt-nephrosys
                :portal="true"
                @buscar="buscar"
                ></importar-txt-nephrosys>
        </div>

        <div v-if="recepcoes && recepcoes.length > 1">
            <table class="table table-sm border-0 mb-1 table-responsive">
                <tr>
                    <td class="text-nowrap">
                        <a href="#" @click.prevent="filtrar(recep)" v-for="(recep, icx) in recepcoes" :key="icx">
                            <span class="badge badge-success mr-1" >
                                {{ recep }}
                            </span>
                        </a>
                    </td>
                </tr>
            </table>
        </div>

        <div v-else-if="lista_origem && lista_origem.length > 1">
            <table class="table table-sm border-0 mb-1 table-responsive">
                <tr>
                    <td class="text-nowrap">
                        <a href="#" @click.prevent="filtrar(origem.origem)" v-for="(origem, icx) in lista_origem" :key="icx">
                            <span class="badge badge-success mr-1" >
                                {{ origem.origem }}
                                <span class="badge badge-light ml-2" v-if="origem.qtd">
                                    {{ origem.qtd }}
                                </span>
                            </span>
                        </a>
                    </td>
                </tr>
            </table>
        </div>

        <az-empty-state 
            icon="fa-solid fa-user" 
            :msg="dados === null ? 'Buscar Pacientes' : 'Nenhum Paciente Identificado'" 
            :action="dados === null ? 'Buscar' : ''"
            :method="load"
            v-if="!lista || !lista.length" />

        <template v-else-if="selecionado">
            <div class="alert alert-primary d-flex justify-content-between">
                <div>
                    <div>
                        <span class="lead">{{ selecionado.paciente.st_nome }},</span> {{ selecionado.paciente.cadastro.ch_sexo }}, {{ selecionado.paciente.cadastro.idade }} 
                    </div>
                    <div v-if="selecionado.paciente.cadastro.st_cpf">
                        CPF: {{ $util.formatMask(selecionado.paciente.cadastro.st_cpf, 'cpf') }}
                    </div>
                </div>
                <button type="button" class="btn btn-primary" @click="selecionado = null">Voltar</button>
            </div>

            <div class="mb-3" v-if="selecionado.marcacao && selecionado.marcacao.st_id_externo && selecionado.marcacao.st_id_externo.indexOf('.') < 0">
                <az-input 
                    sizing="sm"
                    type="checkbox-group"
                    label="Timbrado"
                    v-model="timbrado"
                    @click="set_timbrado" />
            </div>

            <portal-resultados ref="results" :timbrado="timbrado" :id_paciente="selecionado.id_paciente" />
        </template>

        <template v-else>

            <template v-if="imprimindo_etiquetas">

                <div class="form-row mb-3">
                    <div class="col col-12">
                        <az-input
                            type="button-group"
                            :optionsList="$store.state.user.model.fl_imp_bloco ? 
                            [
                                { id: 'E', search: 'Etiquetas' },
                                { id: 'L', search: 'Laudos' },
                                { id: 'R', search: 'Lista' }
                            ]
                            : [
                                { id: 'E', search: 'Etiquetas' },
                                { id: 'R', search: 'Lista' }
                            ]"
                            optionsData="id"
                            optionsDisplay="search"
                            v-model="tipo_impressao" />
                    </div>
                </div>

                <div class="alert d-flex justify-content-between alert-secondary" v-if="tipo_impressao == 'R'">
                    <div>
                        Imprimir Lista de Pacientes: <strong>{{ lista.length }}</strong>
                    </div>
                    <div>
                        <a href="#" @click.prevent="imprimir_lista('lista-pacientes')" class="card-link" v-if="!$store.state.loading">
                            <i class="fa fa-print" aria-hidden="true"></i> Imprimir 
                        </a>
                        <span v-else>
                            <div class="spinner-border spinner-border-sm" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </span>
                    </div>
                </div>

                <div class="alert d-flex justify-content-between" :class="tipo_impressao == 'L' ? 'alert-success' : 'alert-info'" v-else>
                    <div>
                        <i class="fa-solid fa-barcode fa-fw mr-3" v-if="tipo_impressao == 'E'"></i>
                        <i class="fa-regular fa-file-lines fa-fw mr-3" v-if="tipo_impressao == 'L'"></i>

                        Imprimir {{ tipo_impressao == 'L' ? 'laudos' : 'etiquetas' }} dos atendimentos selecionados. <strong>{{ selecionados.length }}/{{ lista.length }}</strong>
                    </div>
                    <div>
                        <a href="#" @click.prevent="imprimir_etiquetas()" class="card-link" v-if="!$store.state.loading">
                            <i class="fa fa-print" aria-hidden="true"></i> Imprimir 
                        </a>
                        <span v-else>
                            <div class="spinner-border spinner-border-sm" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </span>
                    </div>
                </div>

            </template>

            <div v-if="imprimindo_etiquetas && tipo_impressao == 'R'" id="lista-pacientes">
                <cabecalho-generico titulo="Lista de Pacientes">
                    <div v-if="$store.state.user.model">{{ $store.state.user.model.search }}</div>
                    <div>{{ $store.state.user.st_login }}</div>
                </cabecalho-generico>

                <table class="table table-sm bg-white small">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Paciente</th>
                            <th>CPF</th>
                            <th>Plano</th>
                            <th>Data</th>
                            <th>Atend</th>
                            <th>Unidade</th>
                            <th v-if="tem_origem_lista">Origem</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, iix) in lista" :key="iix">
                            <td>
                                {{ iix + 1 }}
                            </td>
                            <td>
                                {{ item.paciente.st_nome }}, {{ item.paciente.cadastro.ch_sexo }}, {{ item.paciente.cadastro.idade }}
                            </td>
                            <td>
                                {{ item.paciente.cadastro.st_cpf ? $util.formatMask(item.paciente.cadastro.st_cpf, 'cpf') : '' }}
                            </td>
                            <td>
                                {{ item.plano.search }}
                            </td>
                            <td>
                                {{ $util.getFormatDate(item.dt_inicio) }} {{ item.dt_inicio.slice(11,16) }}
                            </td>
                            <td>
                                #{{ item.id_atendimento }}

                                <span class="badge badge-secondary ml-1" v-if="item.marcacao && item.marcacao.st_codigo_reserva && item.marcacao.st_codigo_reserva.includes('.')">
                                    {{ item.marcacao.st_codigo_reserva }}
                                </span>
                            </td>
                            <td>
                                {{ item.marcacao.unidade_operacao.st_nome }} 
                                <span v-if="item.marcacao.recepcao"> / {{ item.marcacao.recepcao.st_nome}}</span>
                            </td>
                            <td v-if="tem_origem_lista">
                                <span v-if="item.apoiado_origem">{{ item.apoiado_origem }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <template v-else>

                <button type="button" class="btn btn-outline-primary btn-sm mb-3" @click="toggle_selecao()" v-if="imprimindo_etiquetas">Todos</button>

                <div class="text-right">
                    <span class="badge badge-secondary">
                        {{ lista.length }}
                    </span>
                </div>
                
                <div class="list-group">
                    <div class="list-group-item" v-for="(item, iix) in lista" :key="iix">
                        <div class="form-row">
                            <div class="col col-12 col-md-1" v-if="imprimindo_etiquetas">
                                <az-input type="checkbox" v-model="item.selecionado" :edicao="tipo_impressao != 'L' || item.pronto" />
                            </div>
                            <div class="col col-12" :class="imprimindo_etiquetas ? 'col-md-5' : 'col-md-6'">
                                <a href="#" @click.prevent="!imprimindo_etiquetas ? selecionado = item : null">
                                    <div>
                                        <span class="lead">{{ item.paciente.st_nome }},</span> {{ item.paciente.cadastro.ch_sexo }}, {{ item.paciente.cadastro.idade }} 
                                    </div>
                                </a>
                                <div class="small" v-if="item.paciente.cadastro.st_cpf">
                                    CPF: {{ $util.formatMask(item.paciente.cadastro.st_cpf, 'cpf') }}
                                </div>
                                <div class="small">
                                    {{ item.plano.search }}   
                                </div>    
                            </div>
                            <div class="col col-12 col-md-1">
                                <div class="text-danger" v-if="item.atendimento_procedimentos_count > 0" title="Exames Pendentes">
                                    <a href="#" @click.prevent="editar_pedido(item)" class="card-link text-danger">
                                        <i class="fa-solid fa-vial-circle-check fa-fw mr-1"></i>
                                        {{ item.atendimento_procedimentos_count }} 
                                        <div>
                                            {{ item.atendimento_procedimentos_count > 1 ? 'Pendentes' : 'Pendente' }}
                                        </div>
                                    </a>
                                </div>
                                <div v-if="item.etapa">
                                    <span style="white-space: pre-wrap;">{{ item.etapa }}</span>
                                </div>
                                <div v-if="item.pronto">
                                    <span class="badge badge-success">
                                        <span v-if="item.novos" class="mr-1">Novos</span>
                                        Resultados Disponíveis
                                    </span>
                                </div>
                                <div v-if="item.recoleta">
                                    <span class="badge badge-warning">Recoleta</span>
                                </div>
                            </div>
                            <div class="col col-12 col-md-5 text-right">
                                <span v-if="item.marcacao && item.marcacao.terceiro_login" class="mr-2">
                                    <a href="#" @click.prevent="ver_login_portal(item)" class="card-link" title="Login/Senha de Acesso ao Portal">
                                        <i class="fa-solid fa-user-shield"></i>
                                    </a>
                                </span>
                                {{ $util.getFormatDate(item.dt_inicio) }} {{ item.dt_inicio.slice(11,16) }}<br>
                                #{{ item.id_atendimento }}
                                <template v-if="item.marcacao">
                                    <span class="ml-1" v-if="item.marcacao.st_id_externo">/ {{ item.marcacao.st_id_externo }}</span>
                                    <span class="ml-1" v-if="item.marcacao.st_codigo_reserva && item.id_apoiado && !isNaN(item.marcacao.st_codigo_reserva)">/ {{ item.marcacao.st_codigo_reserva }}</span>
                                </template> <br>
                                {{ item.marcacao.unidade_operacao.st_nome }} 
                                <span v-if="item.marcacao.recepcao"> / {{ item.marcacao.recepcao.st_nome}}</span>
                                <span v-if="item.apoiado_origem"> / 
                                    <a href="#" @click.prevent="filtrar(item.apoiado_origem.st_nome)" class="card-link">
                                        {{ item.apoiado_origem.st_nome}}
                                    </a>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

            </template>

            <pre v-if="false">{{ dados }}</pre>

        </template>

        <br><br><br><br><br>

        <!-- Login Acesso Portal Modal -->
        <div class="modal fade" id="loginAcessoPortalModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="info_login">
                    <div class="modal-header">
                        <h5 class="modal-title">Login de Acesso ao Portal
                            <span class="badge badge-secondary ml-2" title="Id do Paciente">
                                {{ info_login.id_paciente }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info">
                            {{ info_login.paciente.st_nome }}, {{ info_login.paciente.cadastro.ch_sexo }}, {{ info_login.paciente.cadastro.idade }}
                        </div>

                        <div class="alert alert-secondary d-flex justify-content-between">
                            <div>
                                Login: {{ info_login.marcacao.terceiro_login.st_login }}
                            </div>
                            <div>
                                <a href="#" @click.prevent="copiar_texto(info_login.marcacao.terceiro_login.st_login)">
                                    <i class="fa-solid fa-copy"></i>
                                </a>
                            </div>
                        </div>

                        <div class="alert alert-secondary d-flex justify-content-between">
                            <div>
                                Senha: {{ info_login.marcacao.terceiro_login.st_senha }}
                            </div>
                            <div>
                                <a href="#" @click.prevent="copiar_texto(info_login.marcacao.terceiro_login.st_senha)">
                                    <i class="fa-solid fa-copy"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzPeriodo from '../shared/forms/AzPeriodo.vue';
import AzInput from '../shared/forms/AzInput.vue';
import AzEmptyState from '../util/AzEmptyState.vue';
import PortalResultados from './PortalResultados.vue';
import ImportarXmlSmart from '../shared/ImportarXmlSmart.vue';  
import ImportarTxtNephrosys from '../shared/b2b/ImportarTxtNephrosys.vue';
import CabecalhoGenerico from '../relatorios/shared/CabecalhoGenerico.vue';
import { subscribe, unSubscribe } from "../../service/Notify.js";

export default {
    data() {
        return { 
            filtros: { 
                periodo: 'h', 
                nome_paciente: '', 
                pesquisa: "", 
                hora_inicio: "00:00",
                hora_fim: "23:59",
                horarios: false, 
                info_proc: false, 
                info_pac: false, 
                procedimento: "", 
                status: "", 
                paciente: "",
            },
            dados: null, 
            selecionado: null, 
            imprimindo_etiquetas: false, 
            info_login: null, 
            timbrado: false, 
            tipo_impressao: "E", 
            progresso_laudos: 0, 
            canal_laudo_lote: null,
        }
    },

    components: {
        AzPeriodo,
        AzInput, 
        AzEmptyState, 
        PortalResultados, 
        ImportarXmlSmart, 
        ImportarTxtNephrosys, 
        CabecalhoGenerico, 
    },

    computed: { 
        tem_origem_lista: function () { 
            if ( this.lista.find(item => item.apoiado_origem) ) { 
                return true;
            }

            return false;
        },

        recepcoes: function () { 

            if ( !this.dados ) { 
                return [];
            }

            return _.uniq(
                this.dados.filter(atd => { 
                    return atd.marcacao.recepcao;
                })
                .map(atd => { 
                    return atd.marcacao.recepcao.st_nome;
                })
                .sort()
            );
        },

        lista_origem: function () { 
            if ( !this.dados ) { 
                return [];
            }

            return _.map(
                _.groupBy(
                    _.orderBy(
                        this.dados.filter(atd => atd.apoiado_origem), 
                        'apoiado_origem.st_nome'
                    ), 
                    'apoiado_origem.st_nome'
                ),
                (items, origem) => { 
                    return { 
                        origem: origem, 
                        qtd: items.length
                    }
                }
            );
        },

        lista: function () { 
            if ( !this.dados )
                return [];

            if ( this.filtros.pesquisa && this.filtros.pesquisa.slice(0,1) == '#' && !isNaN(this.filtros.pesquisa.slice(1)) ) { 
                return this.dados.filter(item => item.id_atendimento == this.filtros.pesquisa.slice(1));
            } 

            let reg = this.$util.getregex(this.filtros.pesquisa);
            return this.dados.filter(item => !this.filtros.pesquisa || reg.test(JSON.stringify(item)))  
                .filter(item => !this.imprimindo_etiquetas || this.tipo_impressao != 'L' || item.pronto);
        },

        selecionados: function () { 
            return this.lista.filter(item => item.selecionado);
        }
    },

    updated() { 
        $('[data-toggle="tooltip"]').tooltip();
    },

    methods: { 
        imprimir_lista (printid) { 
            this.$nextTick(() => { 
                this.$util.htmlToPaper(printid, null, () => {
                    console.log("Printing");
                });
            });
        },

        buscar (lista) { 
            console.log('buscar', lista);

            let ids = ( lista && lista.length ) ? lista.map(item => '#' + item).join(', ') : '';

            console.log('ids', ids);

            if ( ids && ids.length ) { 
                this.filtros.pesquisa = ids;
                this.load();
            }
        },

        set_timbrado () { 
            this.$util.setCookie('pert', this.timbrado ? 'N' : 'S');
        },

        editar_pedido (item) { 
            if ( item && item.marcacao && this.$store.state.user.model && this.$store.state.user.model.fl_cad_portal ) { 
                this.$router.push({ 
                    name: 'apoiocadastro',
                    params: { 
                        id_marcacao: item.marcacao.id_marcacao, 
                    }
                });
            }
        },

        copiar_texto (texto) { 
            this.$util.copiar_clipboard(this, texto);
        },

        ver_login_portal (atendimento) { 
            this.info_login = _.cloneDeep(atendimento);
            $('#loginAcessoPortalModal').modal('show');
        },

        toggle_selecao () { 
            let todos = this.lista.filter(item => item.selecionado).length == this.lista.length;
            this.lista.forEach(item => item.selecionado = !todos);
        },

        filtrar (texto) { 
            if ( this.filtros.pesquisa == '"' + texto + '"') { 
                this.filtros.pesquisa = "";
            } else { 
                this.filtros.pesquisa = '"' + texto + '"';
            }
        },

        abrir_pagina_aguarde () { 
            let ref = window.open('', '_blank');

            ref.document.open();
            ref.document.write(`
                <!DOCTYPE html>
                <html>
                <head>
                    <title>Preview</title>
                    <style>
                    body { font-family: Arial; padding: 20px; }
                    </style>
                </head>
                <body>
                    <div id="conteudo" style="text-align: center;">
                    <h1>Gerando Laudos... Aguarde...</h1>
                    <h2>0%</h2>
                    </div>
                </body>
                </html>
            `);
            ref.document.close();

            return ref; 
        },

        atualizar_pagina_aguarde (dados) { 
            if ( this.pagina_laudo && !this.pagina_laudo.closed ) { 

                let conteudo = this.pagina_laudo.document.getElementById('conteudo');

                if ( conteudo ) { 

                    let linkHtml = '';

                    if ( dados.link ) { 
                        linkHtml = `<h1>Processo Concluído</h1><h2>100%</h2><h2><a href="${dados.link}">Ver Laudos</a></h2>`;
                    } else if ( dados.status_code > 400 ) { 
                        linkHtml = `<h1>Ocorreu um erro ao gerar os laudos.</h1><h2>${dados.msg}</h2>`;
                    } else { 
                        linkHtml = `<h1>Gerando Laudos... Aguarde...</h1><h2>${Math.round( ( dados.progresso / dados.total ) * 100 )}%</h2>`;
                    }

                    conteudo.innerHTML = `<!DOCTYPE html>
                        <html>
                        <head>
                            <title>Preview</title>
                            <style>
                            body { font-family: Arial; padding: 20px; }
                            </style>
                        </head>
                        <body>
                            <div id="conteudo" style="text-align: center;">
                            ${linkHtml}
                            </div>
                        </body>
                        </html>
                    `;

                }
            }
        },

        imprimir_etiquetas () { 
            let lista = this.lista.filter(item => item.selecionado && ( this.tipo_impressao != 'L' || item.pronto ))
                .map(item => { 
                    return { 
                        id_atendimento: item.id_atendimento
                    }
                });

            if ( !lista.length ) { 
                this.$toast.add({ 
                    severity: 'error', 
                    summary: 'Nenhum atendimento selecionado', 
                    detail: 'Selecione os atendimentos que deseja imprimir as etiquetas.', 
                    life: 5000
                });
                return;
            }

            let titulo = this.tipo_impressao == 'L' ? 'LAUDOS' : 'ETIQUETAS';
            
            if ( !confirm('Deseja imprimir ' + titulo + ' dos atendimentos listados?') ) { 
                return;
            }

            if ( this.tipo_impressao == 'L' ) { 

                this.canal_laudo_lote = 'imp-lote-laudos-' + this.$util.uuidv4();
                this.progresso_laudos = 0; 

                this.pagina_laudo = this.abrir_pagina_aguarde(); 

                subscribe(this.$store.state.dominio, this.canal_laudo_lote, (retorno) => {

                    console.log('subscribe retorno', retorno);

                    if ( retorno && retorno.data && retorno.data.link ) { 
                        
                        // window.open(retorno.data.link, '_blank');

                        this.atualizar_pagina_aguarde(retorno.data);

                        // this.pagina_laudo.location.href = retorno.data.link;

                        unSubscribe(this.$store.state.dominio, this.canal_laudo_lote);
                        this.canal_laudo_lote = null; 
                         
                        this.$toast.add({ 
                            severity: 'success', 
                            summary: 'Laudos gerados com sucesso', 
                            detail: 'Os laudos foram gerados e estão disponíveis para impressão.', 
                            life: 5000
                        });

                    } else if ( retorno && retorno.data && ( ( retorno.data.progresso && retorno.data.total ) || ( retorno.data.status_code > 400 ) ) ) { 

                        this.atualizar_pagina_aguarde(retorno.data); 

                        // this.progresso_laudos = Math.round( ( retorno.data.progresso / retorno.data.total ) * 100 );

                    } else if ( retorno && retorno.data && retorno.data.status_code > 400 ) { 

                        this.atualizar_pagina_aguarde(retorno.data); 

                        unSubscribe(this.$store.state.dominio, this.canal_laudo_lote);
                        this.canal_laudo_lote = null; 
                         
                        this.$toast.add({ 
                            severity: 'error', 
                            summary: 'Atenção', 
                            detail: 'Ocorreu um erro ao gerar os laudos.', 
                            life: 5000
                        });

                    }

                });

            }

            this.$util.atualizar(this, { 
                service: 'apoiados',
                func: 'etiquetas', 
                redir_api: true, 
                dados: { 
                    lista: lista, 
                    tipo_impressao: this.tipo_impressao,
                    canal: this.canal_laudo_lote, 
                },
                callback: res => { 
                    if ( this.tipo_impressao == 'L' ) { 
                        if ( res.link ) { 
                            window.open(res.link, '_blank');
                        }
                    } else { 
                        this.imprimindo_etiquetas = false;
                    }
                }
            });
        },

        load() { 
            this.selecionado = null; 

            this.$util.load(this, { 
                service: 'laudos',
                func: 'pacientes_por_solicitante', 
                parms: { 
                    ...this.filtros, 
                },
                loadTo: res => { 
                    this.dados = res.lista.map(item => { 
                        item.selecionado = true;
                        return item;
                    });
                }
            });
        }
    },

    mounted() { 
        this.timbrado = ( this.$util.getCookie('pert') == 'S' ? true : false );
    }
}
</script>
